import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid } from '@mui/material';
import { ModalName, Route } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './CreateGameActivity.styles';
import { GameEntity } from '@okletsplay/core';

type ComponentProps = Partial<Pick<GameEntity, 'id' | 'isMatch' | 'isTournament'>>;

export const CreateGameActivity: FC<ComponentProps> = ({ id: gameId, isMatch, isTournament }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { classes } = useStyles();

  const onMatchClick = useCallback(() => {
    const data = gameId ? { game: { id: gameId } } : undefined;
    dispatch(modalsReducers.openModal({ name: ModalName.CreateMatch, data }));
  }, [dispatch, gameId]);

  const onTournamentClick = useCallback(() => {
    const options = gameId ? { state: { game: { id: gameId } } } : undefined;
    navigate(Route.CreateTournament, options);
  }, [gameId, navigate]);

  if (gameId && !isMatch && !isTournament) return null;

  return (
    <Grid
      container
      rowSpacing={{ xs: 1, sm: 0 }}
      columnSpacing={{ xs: 0, sm: 1 }}
      justifyContent="flex-end"
    >
      {isMatch ? (
        <Grid item xs={12} sm={6}>
          <Button variant="contained" onClick={onMatchClick} className={classes.button} fullWidth>
            Create Match
          </Button>
        </Grid>
      ) : null}

      {isTournament ? (
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            onClick={onTournamentClick}
            className={classes.button}
            fullWidth
          >
            Create Tournament
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};
